import type {OfferAvailability} from "@/serviceWorker/workerComponents/Models/OfferAvailability";
import type {DiscountedOfferModel} from "@/serviceWorker/workerComponents/Models/DiscountedOfferModel";

/**
 * Serwis pomagający w obsłudze cen z NfHotel
 *
 */
export class NfPricesService {
    /**
     * Zwraca aplikowalne ceny dla konkretnej oferty (podaje cenę z aplikowanego planu rabatowego)
     * @param offerPrices
     */
   public getApplicablePrices(offerPrices: OfferAvailability): DiscountedOfferModel {
       if(offerPrices.applied_discount) {
           return offerPrices.discounts[offerPrices.applied_discount];
       } else {
           return offerPrices;
       }
   }
    /**
     * Zwraca cenę za osoby
     * @param applicablePrices
     * @private
     */
    public getBookingPricesSum(applicablePrices: DiscountedOfferModel) {
        let sum = 0;
        for(let booking of applicablePrices.bookings) {
            sum += booking.total;
        }
        return Math.round(sum)/100;
    }
}